/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {  useSelector } from 'react-redux';
import { Polyline, Tooltip } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import { getTrafficStatusRectangle, getTrafficStatusCircle } from '../../../../state/selectors/trafficStatusMap.selector';
import { gradient, zoomLevel2PolylineWeight } from '../../../../utils/mapFunctions';

function TrafficStatusForPositionChoose(props) {
  const { zoomLevel, type } = props;
  const { t } = useTranslation();
  const trafficStatusRectangle = useSelector(getTrafficStatusRectangle);
  const trafficStatusCircle = useSelector(getTrafficStatusCircle);
  const trafficStatus = type === 'circle' ? trafficStatusCircle : trafficStatusRectangle; 
    return (
      <>
        {trafficStatus.length > 0 &&
          trafficStatus.map((status) => {
            const firstPoint = [
              status.polyline.coordinates[0][1],
              status.polyline.coordinates[0][0],
            ];
            const endPoint = [
              status.polyline.coordinates[1][1],
              status.polyline.coordinates[1][0],
            ];
            return (
              <Polyline
                key={status._id}
                positions={[firstPoint, endPoint]}
                pathOptions={{
                  color: gradient(status.velocity / 60),
                  weight: zoomLevel2PolylineWeight(zoomLevel),
                }}
              >
                <Tooltip>
                  <p style={{ margin: 0 }}>{`${t('Velocity')}: ${
                    status.velocity
                  } km/h`}</p>
                  <p style={{ margin: 0 }}>{`${t('Source')}: ${
                    status.source
                  }`}</p>
                </Tooltip>
              </Polyline>
            );
          })}
      </>
    );
}
export default TrafficStatusForPositionChoose;
